module.exports = __webpack_public_path__ + "static/edge-2d858e59616c78c91e4496a7c966e050.svg";